import { Injectable } from '@angular/core';
declare let window: any;

@Injectable({ providedIn: 'root' })
export class RecaptchaService {
  private captchaTokenKey = 'captchaToken';
  private expiryKey = 'captchaExpiry';
  private siteKey = window.config.recaptchaSiteKey;
  private captchaRequestPromise: Promise<string | null> | null = null;

  constructor() {
    this.loadRecaptchaScript();
  }

  private loadRecaptchaScript(): void {
    if ((window as any).grecaptcha) {
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${this.siteKey}`;
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);
  }

  private waitForGrecaptcha(): Promise<void> {
    return new Promise((resolve) => {
      const checkGrecaptcha = () => {
        if ((window as any).grecaptcha) {
          resolve();
        } else {
          setTimeout(checkGrecaptcha, 100);
        }
      };
      checkGrecaptcha();
    });
  }

  async getCaptchaToken(): Promise<string | null> {
    const storedToken = sessionStorage.getItem(this.captchaTokenKey);
    const expiry = sessionStorage.getItem(this.expiryKey);

    if (storedToken && expiry && new Date().getTime() < +expiry) {
      return storedToken;
    }

    if (this.captchaRequestPromise) {
      return this.captchaRequestPromise;
    }

    this.captchaRequestPromise = new Promise(async (resolve) => {
      await this.waitForGrecaptcha(); // Ensure grecaptcha is available

      const grecaptcha = (window as any).grecaptcha;
      if (!grecaptcha) {
        console.error('reCAPTCHA is still not available');
        resolve(null);
        return;
      }

      grecaptcha.ready(() => {
        Promise.resolve(grecaptcha.execute(this.siteKey, { action: 'guest' })) // ✅ Ensures a proper Promise
          .then((token: string) => {
            sessionStorage.setItem(this.captchaTokenKey, token);
            sessionStorage.setItem(
              this.expiryKey,
              (new Date().getTime() + 50 * 60 * 1000).toString(),
            );

            resolve(token);
          })
          .catch((error: any) => {
            console.error('Error executing reCAPTCHA:', error);
            resolve(null);
          })
          .finally(() => {
            this.captchaRequestPromise = null;
          });
      });
    });

    return this.captchaRequestPromise;
  }
}
